const { NODE_ENV, VUE_APP_URL } = process.env;
const baseURL = NODE_ENV === 'development' ? '/api' : VUE_APP_URL + '/api';

export default baseURL;
